import { Component, OnInit, inject } from '@angular/core';
import { CommonFormComponent } from '@ntap/common';
import { ItemViewProviderDirective, Util } from '@ntap/core';
import { TreeNode } from 'primeng/api';
import { Observable, combineLatest, of, take, tap } from 'rxjs';
import { DokItemInfo } from '../dokumentacija/dokumentacija-types';
import {
  Razina,
  TYPE_jedinica_gradiva
} from '../hierarhija/hierarhija.component';
import { KlasifikacijskiSifrarnikService } from './klasifikacijski-sifrarnik.service';

@Component({
  selector: 'app-klas-sifrarnik',
  templateUrl: './klasifikacijski-sifrarnik.component.html',
  styleUrls: ['./klasifikacijski-sifrarnik.component.scss'],
  providers: [KlasifikacijskiSifrarnikService]
})
export class KlasifikacijskiSifrarnikComponent
  extends CommonFormComponent
  implements OnInit
{
  itemViewProvider = inject(ItemViewProviderDirective);
  klasifikacijskiSifrarnikService = inject(KlasifikacijskiSifrarnikService);
  selectedNode: TreeNode | null;
  klasaArray$: Observable<any>;

  override doChangedInputParam(): void {
    this.initComponentData(this.inputParam);
    this.formControl =
      this.formService.getFormControl(this.formControlName) || this.formControl;
    if (this.inputParam.itemValue !== undefined) {
      this.formControl.setValue(this.inputParam.itemValue);
      this.currentValue = this.inputParam.itemValue;
    }
    this.formControlInitialized = true;
    this.formControl.markAsPristine();
  }

  ngOnInit(): void {
    this.itemViewProvider.item$.pipe(take(1)).subscribe((item) => {
      const dokInfo = new DokItemInfo(item);
      const isDokFolder = dokInfo.razina < Razina.PREDMET;
      this.klasaArray$ = isDokFolder
        ? this.klasifikacijskiSifrarnikService.getKlasPodrucje()
        : this.klasifikacijskiSifrarnikService.getKlasDosjeAndPodrucje();
      this.addSubscription(
        combineLatest([of(item), this.klasaArray$])
          .pipe(
            tap(([item, klasaArray]: [any, TreeNode[]]) => {
              let podrucjeId = null;
              let dosjeId = null;
              if (isDokFolder) {
                podrucjeId =
                  item[
                    Util.getFullAttrName(
                      TYPE_jedinica_gradiva,
                      'dokumentacija_klasa'
                    )
                  ];
              } else {
                podrucjeId = item['seup~predmet~klasa_podrucje_id'];
                dosjeId = item['seup~predmet~dosje_id'];
              }
              const currentKlasaId = this.calculateCurrentKlasaValue(
                podrucjeId,
                dosjeId
              );
              if (currentKlasaId) {
                this.selectedNode = this.findObjectOfKlasa(
                  klasaArray,
                  currentKlasaId
                );
                this.setValue(currentKlasaId);
              }
            })
          )
          .subscribe()
      );
    });
  }

  onNodeSelect(event: any) {
    //SET formControl VALUE ON TREESELECT COMPONENT CHANGE
    this.setValue(event.node.data);
  }

  clearSelection() {
    this.selectedNode = null;
    this.formControl.setValue(null);
    this.formControl.markAsDirty();
  }

  calculateCurrentKlasaValue(podrucjeId: number, dosjeId: number) {
    if (!podrucjeId && !dosjeId) {
      return null;
    }
    if (dosjeId) {
      return this.klasifikacijskiSifrarnikService.createTempKlasaForDosje(
        dosjeId
      );
    } else if (podrucjeId) {
      return `${podrucjeId}`;
    }
    return null;
  }

  findObjectOfKlasa(
    klase: TreeNode[],
    existingKlasaId: string | null
  ): TreeNode | null {
    if (!existingKlasaId) {
      return null;
    }
    for (const klasa of klase) {
      if (klasa.data == existingKlasaId) {
        return klasa;
      }
      if (klasa.children) {
        const found = this.findObjectOfKlasa(klasa.children, existingKlasaId);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }
}
